import { MoonIcon, SunIcon } from '@evinced-private/ui-common';

export const THEME_STORAGE_KEY = 'colorTheme';
export const THEME_TRANSITION_DURATION_MS = 300;
export const THEME_OPTIONS = [
	{ label: 'Light Mode', id: 'light', icon: SunIcon },
	{ label: 'Dark Mode', id: 'dark', icon: MoonIcon }
];
